





























import { Component, Prop, Vue } from 'vue-property-decorator';
/* interfaces */
import MainSkill from '@/interfaces/skills/MainSkill';
import GenericObjectValue from '@/interfaces/general/GenericObjectValue';
/* components */
import SkillsTextsListing from '@/components/Skills/SkillsTextsListing.vue';

    @Component({
      components: {
        SkillsTextsListing,
      },
    })
export default class SkillsList extends Vue {
        @Prop() private title!: string;

        @Prop() private menu!: GenericObjectValue<MainSkill>;
}
